import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from '../ErrorMessage';

function ErrorToast({ error, onDismiss, autoHide = true, duration = 5000, title }) {
  const [isVisible, setIsVisible] = useState(false);
  const [isExiting, setIsExiting] = useState(false);

  const handleDismiss = () => {
    setIsExiting(true);
    setTimeout(() => {
      setIsVisible(false);
      if (onDismiss) onDismiss();
    }, 300);
  };

  useEffect(() => {
    if (error) {
      setIsVisible(true);
      setIsExiting(false);

      if (autoHide) {
        const timer = setTimeout(() => {
          handleDismiss();
        }, duration);

        return () => clearTimeout(timer);
      }
    }
    return undefined;
  }, [error, autoHide, duration]);

  if (!error || !isVisible) return null;

  return (
    <div
      className={`fixed top-3 right-4 z-50 w-[min(100vw-2rem,400px)] transform transition-all duration-300 ease-in-out ${
        isExiting ? 'translate-x-full opacity-0' : 'translate-x-0 opacity-100'
      }`}
    >
      <ErrorMessage error={error} onDismiss={handleDismiss} title={title} className='shadow-[0_8px_24px_rgba(11,25,41,0.10)]' />
    </div>
  );
}

ErrorToast.propTypes = {
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  onDismiss: PropTypes.func,
  autoHide: PropTypes.bool,
  duration: PropTypes.number,
  title: PropTypes.string,
};

export default ErrorToast;
